<template>
    <component
        :is="seasonLink ? 'a' : 'div'"
        :href="seasonLink"
        :target="seasonLink ? '_blank' : undefined"
        class="user-portfolio-course"
    >
        <div class="user-portfolio-course__image">
            <img v-if="item.cover && item.cover.url" :src="item.cover.url" alt="" />
            <img v-else src="~@/assets/images/portfolio/no-image.svg" alt="" />
        </div>
        <div
            class="user-portfolio-course__content"
            :class="{
                'user-portfolio-course__content--centered': !hasCompetences,
            }"
        >
            <div class="user-portfolio-course__content-name">
                {{ item.name }}
            </div>

            <template v-if="item.foreignCompetenceIds && item.foreignCompetenceIds.length > 0">
                <div class="course-competence">
                    <div
                        v-for="(competence, index) in foreignCompetenceIdsList"
                        :key="index"
                        class="course-competence-item"
                        :class="{
                            [`course-competence-item--${competence.type}`]: true
                        }"
                    >
                        {{ competence.name }}
                    </div>
                </div>

                <div
                    v-if="item.foreignCompetenceIds && item.foreignCompetenceIds.length > 1"
                    class="course-competence-toggle"
                    :class="{
                        'course-competence-toggle--opened': competencesOpened
                    }"
                    @click="toggleNominationsList"
                >
                    {{ competencesOpened ? 'Свернуть' : 'Развернуть' }}
                </div>
            </template>
        </div>
    </component>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
    props: {
        item: Object,
    },
    data: () => ({
        competencesOpened: false,
    }),
    computed: {
        ...mapGetters('data', [
            'getRegistryItems',
        ]),
        ...mapGetters('competences', [
            'getSoftCompetences',
            'getHardCompetences',
        ]),

        competencesMap() {
            const map = {};

            this.getSoftCompetences.forEach(v => {
                map[v.id] = { type: 'soft', name: v.name };
            });
            this.getHardCompetences.forEach(v => {
                map[v.id] = { type: 'hard', name: v.name };
            });

            return map;
        },

        rsvDomain() {
            return window.rsvDomain;
        },

        seasonLink() {
            const id = this.item.foreignCmsId;

            if (!id) {
                return undefined;
            }

            return `https://${this.rsvDomain}/education/courses/1/${id}`;
        },

        foreignCompetenceIdsList() {
            const list = [...(this.item.foreignCompetenceIds || [])].map(v => (this.competencesMap[v] || {}));
            return this.competencesOpened ? list : list.slice(0, 1);
        },

        hasCompetences() {
            return this.foreignCompetenceIdsList.length > 0;
        },
    },

    methods: {
        toggleNominationsList(e) {
            if (e instanceof Event) {
                e.preventDefault();
            }

            this.competencesOpened = !this.competencesOpened;
        },


    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-course {
    display: flex;
    flex-direction: column;
    gap: mrem(16);

    @include on-desktop {
        display: grid;
        grid-template-columns: rem(180) auto;
        gap: rem(16);
    }

    &:hover {
        text-decoration: none;
    }

    &__image {
        flex: 0 1 auto;

        img {
            width: 100%;
            border-radius: mrem(16);
            aspect-ratio: 16 / 9;
            object-fit: cover;

            @include on-desktop {
                border-radius: rem(16);
            }
        }
    }

    &__content {
        &--centered {
            display: flex;
            align-items: center;
            padding-top: mrem(20);

            @include on-desktop {
                padding-top: rem(20);
            }
        }

        &-name {
            font-weight: 700;
            margin-bottom: mrem(16);

            @include on-desktop {
                margin-bottom: rem(16);
            }
        }
    }

    .course-competence {
        background: #fff;
        border-radius: mrem(16);
        padding: mrem(16);

        @include on-desktop {
            border-radius: rem(16);
            padding: rem(16);
        }

        .course-competence-item {
            display: grid;
            position: relative;
            font-weight: 500;
            grid-template-columns: mrem(24) auto;
            gap: mrem(6);
            padding: mrem(6) 0;

            @include on-desktop {
                grid-template-columns: rem(24) auto;
                gap: rem(6);
                padding: rem(6) 0;
            }

            &:before {
                content: '';
                flex: 0 1 auto;
                display: block;
                width: mrem(24);
                height: mrem(24);

                @include on-desktop {
                    width: rem(24);
                    height: rem(24);
                }
            }
            &--soft {
                &:before {
                    background: url("~@/assets/images/portfolio/competence.svg") no-repeat center center;
                    background-size: contain;
                }
            }
            &--hard {
                &:before {
                    background: url("~@/assets/images/portfolio/competence.svg") no-repeat center center;
                    background-size: contain;
                }
            }

            & + .course-competence-item {
                border-top: rem(1) solid $color-main-primary-light;
            }

        }
    }

    .course-competence-toggle {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 400;
        cursor: pointer;
        gap: mrem(6);
        margin-top: mrem(24);

        @include on-desktop {
            gap: rem(6);
            margin-top: rem(24);
        }

        &::after {
            display: inline-block;
            content: '';
            background: url('~@/assets/images/portfolio/chevron.svg') no-repeat center center;
            background-size: cover;
            width: mrem(24);
            height: mrem(24);

            @include on-desktop {
                width: rem(24);
                height: rem(24);
            }
        }

        &--opened {
            &::after {
                transform: rotate(180deg);
            }
        }
    }
}

</style>
